import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClapboardWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"clapboard-wide, movie, film"} maskId="square-filled-radius-0-stroke-1-IconClapboardWide"><path d="M22 20H2V10H22V20Z" fill="currentColor"/><path d="M6.60938 9H2V4H8.90137L6.60938 9Z" fill="currentColor"/><path d="M13.9014 9H7.70801L10 4H16.1934L13.9014 9Z" fill="currentColor"/><path d="M22 9H15L17.292 4H22V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconClapboardWide;
